import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { InputModule } from '../form/input/input.module';
import { ButtonModule } from '../button/button.module';
import { BoostAdDialogComponent } from './boost-ad-dialog.component';

@NgModule({
	declarations: [BoostAdDialogComponent],
	imports: [SharedModule, InputModule, ButtonModule],
	exports: [BoostAdDialogComponent],
})
export class BoostAdDialogModule {}
